var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5835 5.50065H20.1668V7.33398H18.3335V19.2507C18.3335 19.7569 17.9231 20.1673 17.4168 20.1673H4.5835C4.07724 20.1673 3.66683 19.7569 3.66683 19.2507V7.33398H1.8335V5.50065H6.41683V2.75065C6.41683 2.24439 6.82724 1.83398 7.3335 1.83398H14.6668C15.1731 1.83398 15.5835 2.24439 15.5835 2.75065V5.50065ZM16.5002 7.33398H5.50016V18.334H16.5002V7.33398ZM8.25016 10.084H10.0835V15.584H8.25016V10.084ZM11.9168 10.084H13.7502V15.584H11.9168V10.084ZM8.25016 3.66732V5.50065H13.7502V3.66732H8.25016Z",
    fill: "#637083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteblack);
export default __webpack_public_path__ + "static/media/Deleteblack.a0717b91e8f12b961872f413fbb3b689.svg";
export { ForwardRef as ReactComponent };